<template>
    <CouncilMapLeaflet />
</template>
<script setup>
import { defineAsyncComponent } from "vue";
const CouncilMapLeaflet = defineAsyncComponent(() => import("../lazy/CouncilMapLeaflet.vue"));
</script>
